/**
 * IOCRI institutional logo emblem, sized to match JusticeEmblem exactly.
 * The source image is a black-line seal on white background; a hue/invert
 * filter maps it into the gold/black palette used sitewide.
 */
export default function LogoEmblem({ size = "md" }) {
  const outer = size === "lg" ? "h-14 w-14" : size === "sm" ? "h-8 w-8" : "h-12 w-12";
  return (
    <div
      data-testid="logo-emblem"
      className="flex items-center justify-center"
      aria-label="IOCRI Institutional Logo"
    >
      <div className={`relative flex items-center justify-center rounded-full border border-gold/40 bg-black/60 shadow-[0_0_30px_-8px_rgba(212,175,55,0.55)] overflow-hidden ${outer}`}>
        <img
          src="/iocri-logo.jpg"
          alt="IOCRI logo"
          className="h-full w-full object-cover"
        />
      </div>
    </div>
  );
}
